import { Component } from 'preact';
import ArenaMatchResult from '../ArenaMatchResult';
import { sorceryImageUrl } from '../../utils/cardImageUrl';
import { getLocalApiOrigin } from '../../utils/localApi';

// Dev-only gallery: every ArenaMatchResult permutation without playing a
// match. Open with ?dev=1&matchresult=1.

// Online: player names + profile avatars. Solo: the two decks' Avatar cards.
const PLAYERS = {
  localName: 'ForceOfWill',
  localAvatarUrl: sorceryImageUrl('got-harbinger-b-s', getLocalApiOrigin()),
  remoteName: 'Kaelthorne',
  remoteAvatarUrl: sorceryImageUrl('got-necromancer-b-s', getLocalApiOrigin()),
  solo: false,
};
const SOLO = {
  localName: 'Flamecaller',
  localAvatarUrl: sorceryImageUrl('bet-flamecaller-b-s', getLocalApiOrigin()),
  remoteName: 'Sparkmage',
  remoteAvatarUrl: sorceryImageUrl('bet-sparkmage-b-s', getLocalApiOrigin()),
  solo: true,
};

const RANK = { tier: 'apprentice', division: 3, lp: 42, shieldGamesLeft: 2 };
const base = (over) => ({
  mode: 'ranked', won: true,
  coinsEarned: 120, xpEarned: 340, seasonXpEarned: 90, arcanaShardsEarned: 3,
  durationMinutes: 14, newTotals: { rank: RANK }, lpDelta: 18,
  glicko: { delta: 12 }, competitiveCredited: true,
  seasonRanked: { points: 260, pointsDelta: 24, matchesPlayed: 9 },
  ...over,
});

const SCENARIOS = [
  { key: 'ranked-win', label: 'Ranked win', envelope: base() },
  { key: 'ranked-loss', label: 'Ranked loss', envelope: base({ won: false, coinsEarned: 40, xpEarned: 120, lpDelta: -15, glicko: { delta: -9 }, seasonRanked: { points: 236, pointsDelta: -12, matchesPlayed: 9 } }) },
  { key: 'promoted', label: 'Ranked win, tier promotion', envelope: base({ tierPromoted: true, newTotals: { rank: { ...RANK, tier: 'journeyman', division: 1 } } }) },
  { key: 'demoted', label: 'Ranked loss, demotion', envelope: base({ won: false, demoted: true, lpDelta: -20 }) },
  { key: 'shielded', label: 'Ranked loss, shield held', envelope: base({ won: false, shielded: true, lpDelta: 0 }) },
  { key: 'capped', label: 'Ranked win, hourly cap', envelope: base({ competitiveCapped: true, lpDelta: 0, seasonRanked: null }) },
  { key: 'casual-win', label: 'Casual win', envelope: base({ mode: 'casual', seasonRanked: null }) },
  { key: 'casual-loss', label: 'Casual loss', envelope: base({ mode: 'casual', won: false, seasonRanked: null }) },
  { key: 'sandbox-online-win', label: 'Online sandbox win', envelope: { mode: 'sandbox', won: true, durationMinutes: 6, newTotals: null } },
  { key: 'sandbox-online-loss', label: 'Online sandbox loss', envelope: { mode: 'sandbox', won: false, durationMinutes: 6, newTotals: null } },
  { key: 'solo-win', label: 'Solo, seat 1 wins', solo: true, autoWinner: 'me' },
  { key: 'solo-loss', label: 'Solo, seat 2 wins', solo: true, autoWinner: 'opponent' },
  { key: 'no-contest', label: 'No contest', envelope: { mode: 'sandbox', won: false, durationMinutes: 7, newTotals: null, arbitration: { reason: 'unverified_lone_win_no_contest' } } },
  { key: 'not-recorded', label: 'Not recorded', envelope: { mode: 'sandbox', won: false, durationMinutes: 7, newTotals: null, arbitration: { reason: 'report_failed' } } },
  { key: 'reporting', label: 'Reporting: who won?', reporting: true },
  { key: 'no-art', label: 'Ranked win, no matchup (hub)', envelope: base(), noMatchup: true },
];

export default class MatchResultGallery extends Component {
  state = { key: SCENARIOS[0].key, nonce: 0 };

  render() {
    const { key, nonce } = this.state;
    const sc = SCENARIOS.find((s) => s.key === key);
    const props = sc.reporting
      ? { autoWinner: null, skipRewardClaim: false }
      : sc.solo
        ? { autoWinner: sc.autoWinner, skipRewardClaim: true }
        : { initialEnvelope: sc.envelope, autoWinner: sc.envelope.won ? 'me' : 'opponent' };
    return (
      <div className="fixed inset-0" style={{ background: '#1a1410' }}>
        <div className="absolute top-2 left-2 z-[1300] flex flex-wrap gap-1" style={{ maxWidth: '40cqw' }}>
          {SCENARIOS.map((s) => (
            <button
              key={s.key}
              type="button"
              className="rounded px-2 py-1 text-xs"
              style={{ background: s.key === key ? '#a8863a' : '#2a2116', color: s.key === key ? '#000' : '#d8c8a0' }}
              onClick={() => this.setState({ key: s.key, nonce: nonce + 1 })}
            >
              {s.label}
            </button>
          ))}
          <button type="button" className="rounded px-2 py-1 text-xs" style={{ background: '#2a2116', color: '#d8c8a0' }} onClick={() => this.setState({ nonce: nonce + 1 })}>
            Replay animation
          </button>
        </div>
        <ArenaMatchResult
          key={`${key}-${nonce}`}
          {...props}
          matchup={sc.noMatchup ? null : sc.solo ? SOLO : PLAYERS}
          roomCode={sc.noMatchup ? null : 'DEV-GALLERY'}
          onWatchReplay={sc.noMatchup ? null : () => {}}
          matchDurationMinutes={sc.solo ? 6 : 0}
          roundsPlayed={7}
          getMatchLog={() => null}
          onClose={() => this.setState({ nonce: nonce + 1 })}
        />
      </div>
    );
  }
}
